<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader/>
    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">

      <LeftMenu/>

      <div class="m-grid__item m-grid__item--fluid m-wrapper">

        <!-- BEGIN: Subheader -->
        <div class="m-subheader">
          <div class="d-flex align-items-center">
            <div class="mr-auto">
              <h3 v-if="admin" class="m-subheader__title">{{admin.Name}}
              </h3>
              <h3 v-else class="m-subheader__title">{{$t('Dashboard.Dashboard')}}
              </h3>
            </div>
          </div>
        </div>
        <!-- END: Subheader -->

        <div class="m-content">

          <LoginAs :ref="'loginAs'"></LoginAs>

        </div>

      </div>
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AdminFooter/>
    <!-- END: Footer -->
  </div>
</template>

<script>
  import AppHeader from '@/components/dashboard/admin/common/Header';
  import AdminFooter from '@/components/dashboard/admin/common/Footer';
  import LeftMenu from '@/components/dashboard/admin/common/menus/LeftMenu';
  import LoginAs from '@/components/dashboard/admin/LoginAs';
  import functions from "@/plugins/functions"

  export default {
    mounted() {

      this.admin = functions.getAdmin()

      if (this.admin == null){
        this.$router.replace('/')
        return;
      }
    },
    components: {
      AdminFooter,
      AppHeader,
      LeftMenu,
      LoginAs
    },
    data() {
      return {
        admin: {},
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/admin/HomePage.vue